/**
 * Category template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/
import Global from './lib/global';
import Logger from './lib/logger';
import { ThemeFullBackgroundCarousel } from "./partials/ThemeFullBackgroundCarousel";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
const NAME = 'CATEGORY';
const prevPageButtonDom = document.querySelector(`[data-prev-button]`);
const nextPageButtonDom = document.querySelector(`[data-next-button]`);
const category = document.querySelector(`[data-category]`);

var categoryName = '';
if (category) {
	categoryName = '/' + category.getAttribute('data-category').toLowerCase();
}

let heroCarousel;
const heroCarouselDom = document.getElementById("hero_carousel");

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initPaginators();
	checkIfPagedContentRequested();

	/**
	 * Initialize the “HERO” Carousel
	 */
	if (heroCarouselDom) {
		heroCarousel = new ThemeFullBackgroundCarousel();
	}
}

/**
 * initPaginators - Initialize the pagination buttons
 */
const initPaginators = () => {
	Logger.info(`${NAME} > initPaginators`);

	prevPageButtonDom.addEventListener('click', (e) => {
		Logger.log(`${NAME} > initPaginators > Previous`);
		e.preventDefault();
		const page = parseInt(prevPageButtonDom.getAttribute('data-page'));
		window.location.href = window.location.origin + `/category` + categoryName + `/page/${page - 1}/`;
	});

	nextPageButtonDom.addEventListener('click', (e) => {
		Logger.log(`${NAME} > initPaginators > Next`);
		e.preventDefault();
		const page = parseInt(nextPageButtonDom.getAttribute('data-page'));
		window.location.href = window.location.origin + `/category` + categoryName + `/page/${page + 1}/`;
	});
}

/**
 * On page load, check whether the requested page was for paged content having to do with the articles scroll pane.
 * If it is in fact paged-content, scroll the user down to the component and apply an offset to clear the global nav.
 */
function checkIfPagedContentRequested() {
	if (window.location.href.toLowerCase().indexOf('page') !== -1) {
		const element = document.getElementById('articles');
		const offset = 45;
		const elementPosition = element.getBoundingClientRect().top;
		const offsetPosition = elementPosition + window.scrollY - offset;

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
	}
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
